import React from "react";

const Transition = ({ show, children, className = "", enter, enterFrom, enterTo }) => {
  if (!show) return null;

  const classes = [enter, enterFrom, enterTo, className].filter(Boolean).join(" ");
  return <div className={classes}>{children}</div>;
};

export default Transition;
